<article class="coupon" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <div class="content">
    <div class="box">
      <ng-container>
        <h3 langkey="coupons_scan"></h3>
        <div class="icon" inlineSVG="sot/sot-icon.svg#sot-coupon-ani" [setSVGAttributes]="{class: 'box-icon'}">
        </div>
        <p langkey="coupons_scan_text"></p>
      </ng-container>
      <footer>
        <a class="btn clear" (click)="openManualCouponInput()" langkey="coupons_enter_code"></a>
      </footer>
      <div class="down-scan" inlineSVG="sot/sot-icon.svg#sot-down_arrows" [setSVGAttributes]="{class: 'arrows'}">
      </div>
    </div>
  </div>
  <footer>
    <div class="footer-btn">
      <sot-backbtn (click)="back()"></sot-backbtn>
    </div>
  </footer>
</article>